// apps/periverse/src/app/utils/render-fatal-error.ts

/**
 * Renders a fatal startup error as plain text in the given root element.
 * Uses textContent (not innerHTML) so the error message — which can contain
 * attacker-influenced content via a thrown Error's `message` — is never
 * parsed as HTML.
 *
 * The "Application failed to load" string below is intentionally not routed
 * through i18n-shared: this runs in bootstrap()'s catch block, which can
 * fire before initI18n() has completed, so calling t() here could itself
 * throw and mask the original startup error.
 */
export function renderFatalError(rootElementId: string, message: string): void {
  const root = document.getElementById(rootElementId);
  if (!root) {
    return;
  }

  root.textContent = '';
  const heading = document.createElement('h1');
  heading.textContent = `Application failed to load: ${message}`;
  root.appendChild(heading);
}
